import clsx from 'clsx';
import type { TenantStatusKey } from '@/lib/operatorApi';

const MAP: Record<TenantStatusKey, { label: string; className: string }> = {
  trial:     { label: 'Trial',        className: 'badge-amber' },
  active:    { label: 'Активен',      className: 'badge-green' },
  past_due:  { label: 'Просрочен',    className: 'badge-red' },
  cancelled: { label: 'Отменён',      className: 'badge-ink' },
  // Своей подписки у точки ещё нет: заведётся первым же действием оператора.
  none:      { label: 'Нет подписки', className: 'badge-ink' },
};

export default function StatusBadge({ status }: { status: TenantStatusKey }) {
  const s = MAP[status] ?? MAP.trial;
  return <span className={clsx(s.className)}>{s.label}</span>;
}
